"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var Icon_1 = require("../Icon/Icon");
var HeaderTitle = /** @class */ (function (_super) {
    __extends(HeaderTitle, _super);
    function HeaderTitle(props) {
        return _super.call(this, props) || this;
    }
    HeaderTitle.prototype.render = function () {
        var _a = this.props, children = _a.children, backButtonTitle = _a.backButtonTitle, onBackButtonClick = _a.onBackButtonClick, className = _a.className, style = _a.style;
        var classes = classNames('simple-header__title-root', className);
        var titleElement = typeof children === 'string' ? React.createElement("h2", null, children) : children;
        return (React.createElement("div", { className: classes, style: __assign({ display: 'flex', flexDirection: 'column' }, style) },
            backButtonTitle && (React.createElement("a", { className: "simple-header__back-button", onClick: onBackButtonClick },
                React.createElement(Icon_1.default, { icon: "angle-left", size: "lg" }),
                React.createElement("span", null, backButtonTitle))),
            React.createElement("div", { className: "simple-header__title" }, titleElement)));
    };
    return HeaderTitle;
}(React.Component));
exports.default = HeaderTitle;
//# sourceMappingURL=HeaderTitle.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/HeaderTitle/HeaderTitle.js
// module id = 238
// module chunks = 0